import { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@altimateai/lego";
import { OwnershipRulesFormValues } from "./types";

interface OwnershipTagFieldsProps {
  form: UseFormReturn<OwnershipRulesFormValues>;
  index: number;
}

const OwnershipTagFields = ({ form, index }: OwnershipTagFieldsProps) => {
  return (
    <>
      <FormField
        control={form.control}
        name={`ownerships.${index}.condition_key_value`}
        render={({ field }) => (
          <FormItem>
            <FormLabel>Key</FormLabel>
            <FormControl>
              <Input placeholder="Enter key" {...field} className="!al-m-0" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <div className="al-mt-2">
        <FormField
          control={form.control}
          name={`ownerships.${index}.condition_value`}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Value</FormLabel>
              <FormControl>
                <Input placeholder="Enter value" {...field} className="!al-m-0" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </>
  );
};

export default OwnershipTagFields;
